import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AppContainer from "../Structure/AppContainer";
import Select from "react-select";
import AuthContext from "../../Context/AuthContext";
import ajaxRequisitions from "../../util/remote/ajaxRequisitions";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxDepartments from "../../util/remote/ajaxDepartments";
import RejectedItemsRequisitionDetailsModal from "./RejectedItemsRequisitionDetailsModal";
const ViewRequisitionsWzRejectItems = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  // States
  const [loading, setLoading] = useState(false);
  const [requisitions, setRequisitions] = useState([]);
  const [page, setPage] = useState(1);
  const [deptID, setDeptID] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [view_details, setView_details] = useStateCallback(false);
  const [departments, setDepartments] = useState([]);
  // Default ToDate = today
  useEffect(() => {
    const today = new Date();
    const localDate = today.toLocaleDateString("en-CA"); // local date in YYYY-MM-DD
    setToDate(localDate);
  }, []);
  // Fetch departments
  const fetch_departmentList = async () => {
    const res = await ajaxDepartments.fetchDepartmentsList({});
    if (res.status === "OK") {
      setDepartments(
        res.details.map((d) => ({ value: d.id, label: d.department }))
      );
    } else {
      toast.error(res.message);
    }
  };
  useEffect(() => {
    fetch_departmentList();
  }, []);
  // Fetch requisitions list
  const fetchRequisitionsList = async () => {
    setLoading(true);
    const data = {
      page,
      from_date: fromDate,
      to_date: toDate,
      deptID: deptID?.value || "",
    };
    setRequisitions([]);
    try {
      const res =
        await ajaxRequisitions.fetchRequisitionsListWith_rejected_items(data);
      if (res.status === "OK") {
        setRequisitions(res.details);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error("Failed to fetch requisitions.");
    } finally {
      setLoading(false);
    }
  };
  // Initial & paginated fetch
  useEffect(() => {
    fetchRequisitionsList();
  }, [page]);
  // View rejected items modal
  const handleView_details = (data) => {
    setView_details(false, () =>
      setView_details(
        <RejectedItemsRequisitionDetailsModal
          data={data}
          func={fetchRequisitionsList}
        />
      )
    );
  };
  // Filters
  const handleFilter = () => {
    setPage(1);
    fetchRequisitionsList();
  };
  const handleResetFilters = () => {
    setFromDate("");
    setToDate(new Date().toISOString().split("T")[0]);
    setDeptID("");
    setPage(1);
    fetchRequisitionsList();
  };
  return (
    <AppContainer title="Requisitions View">
      <div className="container-fluid">
        <Toaster />
        {/* Modals */}
        {view_details}
        {/* Create button */}
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/requsition/create")}
            >
              Create Requisition
            </button>
          </div>
        </div>
        {/* Filters */}
        <div className="card custom-card card-dashboard-calendar pb-0 mb-3">
          <div className="row p-3">
            <div className="col-lg-3">
              <label>From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="col-lg-3">
              <label>To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label>
                Department <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                options={departments}
                value={deptID}
                onChange={setDeptID}
                placeholder="Select Department"
              />
            </div>
            <div className="col-lg-2 d-flex align-items-end">
              <button
                className="btn btn-success btn-sm me-2"
                onClick={handleFilter}
                disabled={loading}
              >
                {loading ? "Loading..." : "Filter"}
              </button>
              <button
                className="btn btn-secondary btn-sm"
                onClick={handleResetFilters}
                disabled={loading}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
        {/* Requisitions Table */}
        <div className="card custom-card card-dashboard-calendar pb-0">
          <label className="main-content-label mb-2 pt-1">
            Organisation Requisitions
          </label>
          <span className="d-block tx-12 mb-2 text-muted">
            List of registered requisitions
          </span>
          <table className="table table-striped table-hover table-responsive">
            <thead>
              <tr>
                <th>NO</th>
                <th>Narration</th>
                <th>Department</th>
                <th>Est. Total</th>
                <th>Approval Level</th>
                <th>Rejected Items</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : requisitions.length ? (
                requisitions.map((req, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{req.naration}</td>
                    <td>{req.department}</td>
                    <td>{req.est_total}</td>
                    <td>{req.approval_level}</td>
                    <td>{req.rejected_items?.length || 0}</td>
                    <td>{req.date_created}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => handleView_details(req)}
                      >
                        <i className="fa fa-eye" /> Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No requisitions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewRequisitionsWzRejectItems;
